import {Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {TenderDetailResponse} from '@frontend/shared-api';
import {Button} from 'primeng/button';
import {SubsectionTitleComponent} from '../../../../../shared/components/header/subsection-title/subsection-title.component';

@Component({
  selector: 'app-tender-invitation-mail',
  imports: [TranslocoPipe, Button, SubsectionTitleComponent],
  templateUrl: './tender-invitation-mail.component.html',
})
export class TenderInvitationMailComponent {
  tenderDetails = input<TenderDetailResponse>();
  nextTab = output<void>();

  get mailText(): string {
    return this.tenderDetails()?.mailText || '';
  }

  goToNextTab(): void {
    this.nextTab.emit();
  }
}
